import React, { useEffect, useMemo, useRef, useState } from "react";
import Dropzone from "react-dropzone";
import { UploadButton } from "./styles";
import UploadIcon from "assets/svgs/uploadFile.svg";
import { Ptag } from "components/core";
import { uploadFile } from "utlis/utils";
import UploadedFileName from "components/UploadFileName";

function MultipleFileUpload({ setWellnessIDs }) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const inputRef = useRef();
  console.log({ selectedFiles });

  useEffect(() => {
    if (!selectedFiles?.length) {
      setWellnessIDs([]);
      return;
    }

    const uploadFiles = async () => {
      try {
        const fileIDS = await Promise.all(
          selectedFiles.map(async (file) => {
            const fileId = await uploadFile(file, "premiums_invoice");
            return fileId;
          })
        );

        const validFileIDS = fileIDS.filter((id) => id);
        setWellnessIDs(validFileIDS);
      } catch (error) {
        console.error("Error uploading files:", error);
        setWellnessIDs([]);
      }
    };

    uploadFiles();
  }, [selectedFiles]);

  const handleFilesSelection = async (files) => {
    setSelectedFiles(files);
  };

  console.log({ selectedFiles });
  const resetFile = (index) => {
    setSelectedFiles([]);
  };

  return (
    <>
      <Dropzone
        accept={{
          "application/pdf": [".pdf"],
        }}
        onDrop={(acceptedFiles) => handleFilesSelection(acceptedFiles)}
      >
        {({ getRootProps, getInputProps }) => (
          <section>
            <UploadButton
              onClick={() => inputRef.current.click()}
              {...getRootProps()}
            >
              <img
                style={{ marginRight: "6px", height: "16px", width: "14px" }}
                src={UploadIcon}
                height="18px"
                width="18px"
              />
              <input ref={inputRef} {...getInputProps()} />
              <Ptag fontSize="14px" fontWeight="600" letterHeight="19px">
                Drag & Drop files
              </Ptag>
            </UploadButton>
          </section>
        )}
      </Dropzone>
      {selectedFiles &&
        selectedFiles.map((file, index) => (
          <UploadedFileName file={file} onClick={() => resetFile(index)} />
        ))}
    </>
  );
}

export default MultipleFileUpload;
